// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__moDx-","empty":"ModalGraph_empty__1nNQ1"};